// export
import { observer } from "mobx-react-lite";
import { motion } from "framer-motion";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import BarChartIcon from "@mui/icons-material/BarChart";
// import SearchIcon from "@mui/icons-material/Search";
import CableIcon from "@mui/icons-material/Cable";
// internal
import "../css/leftBar.scss";

const ObserveLeftBar = observer(({ user, navigate }) => {
    return (
        <div className="left-bar-container">
            <div className="lb-logo-container">
                <span className="lb-logo-text">🗣</span>
            </div>
            <motion.div
                className="lb-icon-container"
                onClick={() => {
                    navigate("/");
                }}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.8 }}
            >
                <span className="grey-icon">
                    <CableIcon />
                </span>
            </motion.div>
            <motion.div
                className="lb-icon-container"
                onClick={() => {
                    navigate("/feed");
                }}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.8 }}
            >
                <span className="grey-icon">
                    <CampaignRoundedIcon />
                </span>
            </motion.div>
            <motion.div
                className="lb-icon-container"
                onClick={() => {
                    navigate("/insights");
                }}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.8 }}
            >
                <span className="grey-icon">
                    <BarChartIcon />
                </span>
            </motion.div>
        </div>
    );
});

const LeftBar = ({ user, navigate }) => {
    return <ObserveLeftBar user={user} navigate={navigate} />;
};

export default LeftBar;
